import classNames from "classnames";
import React, { useEffect, useState, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingModal from "../../components/shared/LoadingModal";
import Modal from "../../components/shared/Modal";
import AuthLayout from "../../layouts/AuthLayout";
import { getGifts } from "../../services/contentService";
import { fetchPointDataAction } from "../../store/app/pointActions";
import ActivePoints from "./components/ActivePoints";
import EarnedPoints from "./components/EarnedPoints";
import NegativePoints from "./components/NegavitePoints";
import PointArrangement from "./components/PointArrangement";
import SpentPoints from "./components/SpentPoints";
// Removed local store bindings and simplified since fetchPointDataAction handles it; keeping only if needed
import { useLocation } from "react-router-dom";
import Parse from "parse";

function Points() {
  const [activeTab, setActiveTab] = useState(1);
  const [gifts, setGifts] = useState(null);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const pointData = useSelector((state) => state.app.pointData);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.prevPath === "/kale-wall") {
      setActiveTab(3);
    }
  }, [location]);

  useEffect(() => {
    // Get currentUser from Parse
    const user = Parse.User.current();
    if (user) {
      setCurrentUser(user.toJSON());
    }
  }, []);

  const activeTabMarkup = () => {
    switch (activeTab) {
      case 1:
        return <ActivePoints pointData={pointData} siteId={currentUser?.siteId} />;
      case 2:
        return <SpentPoints gifts={gifts} siteId={currentUser?.siteId} />;
      case 3:
        return <PointArrangement />;
      case 4:
        return <EarnedPoints pointData={pointData} siteId={currentUser?.siteId} />;
      case 5:
        return <NegativePoints pointData={pointData} siteId={currentUser?.siteId} />;
      default:
        return;
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const gifts = await getGifts();
        setGifts(gifts);
        await dispatch(fetchPointDataAction());
      } catch (error) {
        setApiError(error.message);
        setShowErrorModal(true);
      } finally {
        setLoading(false);
      }
    })();
    //eslint-disable-next-line
  }, []);

  return (
    <AuthLayout>
      {loading && <LoadingModal />}
      <Modal
        shouldShow={showErrorModal}
        updateModalState={(show) => setShowErrorModal(show)}
        msg={apiError}
        type="error"
      />
      <div id="content" className="">
        <div className="px-4 py-5 bg-background-teal md:px-4 lg:py-16 lg:px-0">
          <main className="px-4 mx-auto max-w-7xl lg:px-1">
            <div className="flex flex-col justify-between grid-cols-12 md:grid lg:items-center">
              <div className="col-span-7">
                <h1 className="mb-4 text-md lg:text-xxl text-primary-black font-lg lg:mb-0">
                  Kale Puan
                </h1>
              </div>
            </div>
          </main>
        </div>
        <div className="bg-white">
          <div className="max-w-5xl mx-auto">
            <div className="py-16">
              <div className="max-w-full mb-12 overflow-y-auto text-center">
                <div className="relative z-0 inline-flex bg-secondary-secondary-bg mx-auto p-0.5">
                  <button
                    type="button"
                    onClick={() => setActiveTab(1)}
                    className={classNames(
                      activeTab === 1
                        ? "inline-block !bg-primary-red !text-white active"
                        : "inline-block !text-primary-black !bg-transparent",
                      "w-full p-3 break-normal tab-btn text-primary-black hover:text-white max-w-max"
                    )}
                  >
                    Aktif Puanlarım
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab(2)}
                    className={classNames(
                      activeTab === 2
                        ? "inline-block !bg-primary-red !text-white active"
                        : "inline-block !text-primary-black !bg-transparent",
                      "w-full p-3 break-normal tab-btn text-primary-black hover:text-white max-w-max"
                    )}
                  >
                    Harcadığım Puanlarım
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab(5)}
                    className={classNames(
                      activeTab === 5
                        ? "inline-block !bg-primary-red !text-white active"
                        : "inline-block !text-primary-black !bg-transparent",
                      "w-full p-3 break-normal tab-btn text-primary-black hover:text-white max-w-max"
                    )}
                  >
                    Negatif Puanlarım
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab(4)}
                    className={classNames(
                      activeTab === 4
                        ? "inline-block !bg-primary-red !text-white active"
                        : "inline-block !text-primary-black !bg-transparent",
                      "w-full p-3 tab-btn text-primary-black hover:text-white max-w-max"
                    )}
                  >
                    Kazandığım Puanlarım
                  </button>
                  {currentUser?.siteId !== "tali" && ( // Tali site ise gizle
                    <button
                      type="button"
                      onClick={() => setActiveTab(3)}
                      className={classNames(
                        activeTab === 3
                          ? "inline-block !bg-primary-red !text-white active"
                          : "inline-block !text-primary-black !bg-transparent",
                        "w-full p-3 break-normal tab-btn text-primary-black hover:text-white max-w-max"
                      )}
                    >
                      Kale Puan Sıralamam
                    </button>
                  )}
                </div>
              </div>
              {activeTabMarkup()}
            </div>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}
export default memo(Points);
